import { createContext } from 'react';

import {
  UbiquitiApiDataItem,
  UbiquitiNetwork,
} from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  error: boolean;
  networks: UbiquitiApiDataItem<UbiquitiNetwork>[];
}

export default createContext<Context>({
  loading: false,
  error: false,
  networks: [],
});
